module.exports = __webpack_public_path__ + "img/delete.24ce9137.svg";